import { render } from "./saveProduit.vue?vue&type=template&id=11e41d92&scoped=true"
import script from "./saveProduit.vue?vue&type=script&lang=js"
export * from "./saveProduit.vue?vue&type=script&lang=js"

import "./saveProduit.vue?vue&type=style&index=0&id=11e41d92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e41d92"]])

export default __exports__